import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { EditProfileFormValues } from '../../../../components/form/Form-edit-profile';
import { USER_LOCALSTORAGE_KEY } from '../../../../shared/const/localstorage';
import {
    clearEditProfileErrors,
    editProfileRequest,
    editProfileSuccess
} from '../../slice/editProfileSlice';
import { fetchProfileData } from '../../../../entities/Profile/model/fetchProfileDate/fetchProfileDate';

const getAuthToken = () => {
    const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
    if (!authToken) {
        throw new Error('No token found in localStorage.');
    }
    const { token } = JSON.parse(authToken);
    if (!token) {
        throw new Error('Invalid token format.');
    }
    return token;
};

const updateProfileOnServer = async (requestData: EditProfileFormValues, token: string) => {
    return await axios.post('/api/profile/update', requestData, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const fetchEditProfile = createAsyncThunk(
    'profile/editProfile',
    async (requestData: EditProfileFormValues, thunkAPI) => {
        try {
            const token = getAuthToken();
            thunkAPI.dispatch(editProfileRequest());

            const response = await updateProfileOnServer(requestData, token);

            thunkAPI.dispatch(editProfileSuccess());

            thunkAPI.dispatch(fetchProfileData());

            thunkAPI.dispatch(clearEditProfileErrors(response.data));

            return response.data;


        } catch (error) {
            // @ts-ignore
            throw new Error(error.message);
        }
    }
);
